import React from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material"

export default function DialogAction(props) {
    const closeDialog = () => { props.setOpen(false) }

    const confirmDialog = async () => {
        await props.statusCb(props.row)
        closeDialog()
    }

    return (
        <Dialog open={props.open} keepMounted onClose={closeDialog} aria-describedby="alert-dialog-slide-description">
            <DialogTitle>{props.title ? props.title : "Remover"}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-slide-description">
                    {props.message ? props.message : `Deseja realmente remover esta visita?`}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={confirmDialog}>
                    {props.confirmActionTitle ? props.confirmActionTitle : "Confirmar"}
                </Button>
                <Button onClick={closeDialog} >
                    {props.closeActionTitle ? props.closeActionTitle : "Cancelar"}
                </Button>
            </DialogActions>
        </Dialog>
    )
}